const getLocalData = () => {
  let localCartData = localStorage.getItem("Cart");
  if (localCartData === []) {
    return [];
  } else {
    return JSON.parse(localCartData);
  }
};

export const initialState = {
  cart: [],
  products: [],
};

const reducer = (state, action) => {
  console.log(action, state.products.length);
  switch (action.type) {
    case "Add_To_Cart":
      return {
        ...state,
        cart: [...state.cart, action.item],
      };
    case "ADD_PRODUCTS":
      return {
        ...state,
        products: [ action.item],
      };

    case "Remove_From_Cart":
      let newCart = [...state.cart];
      const index = state.cart.findIndex(
        (cartItem) => cartItem.id === action.id
      );
      if (index >= 0) {
        newCart.splice(index, 1);
      }

      return {
        ...state,
        cart: newCart,
      };
      case "CLEAR_CART":
        return{
          ...state,
          cart:[]
        }

    default:
      return state;
  }
};

export default reducer;
